var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 86,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51 0v78.365h-.32V0h.32zM25.853 0v78.365h-.32V0h.32zM43.839 0v78.365h-.321V0h.32zM61.182 0v78.365h-.32V0h.32zM79.168 0v78.365h-.321V0h.32zM96.51 0v78.365h-.32V0h.32zM113.853 0v78.365h-.321V0h.321zM131.839 0v78.365h-.321V0h.321zM145 79.65H8.229v-.322H145v.321z",
    fill: "#EEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.75 18.576V12.41H8.51v6.166h23.24zM17.716 32.097v-6.166H8.518v6.166h9.198zM48.959 46.762v-6.167H8.511v6.167H48.96zM103.531 61.433v-6.167H8.518v6.167h95.013zM136.129 74.202v-6.166H8.51v6.166H136.13z",
    fill: "#4179A8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26 70.136H0v1.966h5.26v-1.966zM5.26 42.458H0v1.966h5.26v-1.966zM5.26 56.294H0v1.966h5.26v-1.966zM5.26 14.774H0v1.965h5.26v-1.965zM5.26 28.616H0v1.965h5.26v-1.965zM30.37 83.445h-9.025v1.966h9.024v-1.966zM47.995 83.445h-9.024v1.966h9.025v-1.966zM65.62 83.445h-9.024v1.966h9.025v-1.966zM83.253 83.445h-9.025v1.966h9.025v-1.966zM100.878 83.445h-9.025v1.966h9.025v-1.966zM118.503 83.445h-9.024v1.966h9.024v-1.966zM136.136 83.445h-9.025v1.966h9.025v-1.966z",
    fill: "#EEE"
  })));
}
export default SvgBar;